export const changeTheViewContextMenuOption = "bld";
export const densitySectionLabel = "cld";
export const messageHeightSectionLabel = "dld";
export const multipleRowsLabel = "eld";
export const autoSwitchRowStyleLabel = "fld";
export default {changeTheViewContextMenuOption,densitySectionLabel,messageHeightSectionLabel,multipleRowsLabel,autoSwitchRowStyleLabel};